/**
 * imagePopup.js
 *
 * - モバイル版のサービスフローセクションにある、Before・Afterの拡大ポップアップの開閉ロジック
 */

// ポップアップの要素を取得
const beforePatternPopup = document.getElementById('before-pattern-popup');
const afterPatternPopup = document.getElementById('after-pattern-popup');

// 開くボタンの要素を取得
const beforePatternButton = document.getElementById('before-pattern-button');
const afterPatternButton = document.getElementById('after-pattern-button');

// 閉じるボタンの要素を取得
const closeButtons = document.querySelectorAll('.c-image-popup__close-button ');

// ポップアップを開く処理
const showPopup = (pattern) => {
  // スクロールを禁止
  document.body.style.overflowY = 'hidden';

  if (pattern === 'before') {
    beforePatternPopup.showModal();
  } else if (pattern === 'after') {
    afterPatternPopup.showModal();
  }
};

// ポップアップを閉じる処理
const closePopup = () => {
  // スクロールを許可
  document.body.style.overflowY = 'scroll';
  beforePatternPopup.close();
  afterPatternPopup.close();
};

// イベントリスナー
closeButtons.forEach((closeButton) => {
  closeButton.addEventListener('click', closePopup);
});
beforePatternButton.addEventListener('click', () => showPopup('before'));
afterPatternButton.addEventListener('click', () => showPopup('after'));
